import { Badge } from "@/components/ui/badge";

type JobStatus = "not_started" | "in_progress" | "completed" | "pending_review" | "on_hold" | "cancelled";

interface StatusBadgeProps {
  status: string;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  not_started: {
    label: "Not Started",
    className: "bg-status-not-started text-white",
  },
  in_progress: {
    label: "In Progress",
    className: "bg-status-in-progress text-white",
  },
  completed: {
    label: "Completed",
    className: "bg-status-completed text-white",
  },
  pending_review: {
    label: "Pending Review",
    className: "bg-status-pending text-white",
  },
  on_hold: {
    label: "On Hold",
    className: "bg-yellow-500 text-white",
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-red-500 text-white",
  },
};

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const config = statusConfig[status] || {
    label: status.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()),
    className: "bg-muted text-foreground",
  };
  return (
    <Badge className={config.className} variant="default">
      {config.label}
    </Badge>
  );
};